import { createRouter, createWebHistory } from "vue-router";
import { factureXRoutes } from "@/invoice-transmission/router";
import { accountingRoutes } from "@/accounting/router";
import { statisticsRoutes } from "@/statistics/router";
import { administrationRoutes } from "@/administration/router";
import { purchaseRoutes } from "@/purchase/router";
import { marketingRoutes } from "@/marketing/router";
import { coreRoutes } from "@/router/core.route";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    ...coreRoutes,
    ...factureXRoutes,
    ...accountingRoutes,
    ...statisticsRoutes,
    ...administrationRoutes,
    ...purchaseRoutes,
    ...marketingRoutes,
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash };
    }

    return { x: 0, y: 0 };
  },
});

export default router;